import React from 'react'
import { Box } from '@mui/material'
import ThreeDotsMenu from 'src/common/components/ThreeDotsMenu'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

export default function ImageWithMenu({ 
  imageMediaId, 
  index, 
  menuItems = [],
  alt = 'uploaded image' 
}) {
  return (
    <Box 
      className="prescription-image-container"
      sx={{ 
        position: 'relative',
        width: '100%',
        '&:hover .menu-button': {
          opacity: 1,
        },
        '@media print': {
          width: '100%',
          maxWidth: '100%',
          margin: 0,
          padding: 0,
        }
      }}
    >
      <Box
        component="img"
        src={getImageLink(imageMediaId)}
        alt={`${alt} ${index + 1}`}
        crossOrigin="anonymous"
        sx={{
          width: '100%',
          height: 'auto',
          display: 'block',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
          },
          '@media print': {
            width: '100%',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '100vh',
            objectFit: 'contain',
            border: 'none',
            borderRadius: 0,
            boxShadow: 'none',
            backgroundColor: 'transparent',
          }
        }}
      />
      
      {menuItems?.length > 0 && <Box
        className="menu-button hide-on-print-only"
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          opacity: 0.5,
          transition: 'opacity 0.2s ease-in-out',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '50%',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          },
          '@media print': {
            display: 'none !important',
          }
        }}
      >
        <ThreeDotsMenu 
          menuItems={menuItems}
          size="small"
          iconColor="#666"
        />
      </Box>}
    </Box>
  )
} 